import React from "react";
import { Search } from "lucide-react";
import { SearchInput } from "./SearchInput";

interface NumberInputProps {
  label: string;
  placeholder: string;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  startDecorator?: React.ReactNode;
  min?: number;
  className?: string;
}

export const NumberInput = ({
  label,
  placeholder,
  onBlur,
  min = 0,
  startDecorator = <Search className="size-4" />,
  className = "flex-none w-[130px] min-w-0 space-y-0.5",
  ...props
}: NumberInputProps) => (
  <SearchInput
    label={label}
    placeholder={placeholder}
    onBlur={onBlur}
    startDecorator={startDecorator}
    className={className}
    slotProps={{
      input: {
        type: "number",
        min,
      },
    }}
    {...props}
  />
);
